import * as service from './service';
import * as selectors from './selectors';
import * as slice from './slice';

export const lrwSessionStore = {
  service,
  selectors,
  ...slice,
};
